export default {
    methods: {
        handleUser(id) {
            API.get(`client/${id}`).then(res => {
                const activeName = Number(res.typeCode) === 1 ? 'first' : 'second';
                if ((activeName === 'first'
                    && !this.$$filterPermission('客户-潜在客户查看-仅查看分配给自己的')
                    && !this.$$filterPermission('客户-潜在客户查看-可查看全部'))
                    || (activeName === 'second'
                    && !this.$$filterPermission('客户-会员查看-仅查看分配给自己的')
                    && !this.$$filterPermission('客户-会员查看-可查看全部') )) {
                    return this.$router.push('/403');
                }
                this.$router.push({
                    name: 'Client',
                    query: {
                        activeName: activeName,
                        clientId: id,
                    },
                });
            });
        },
    },
};
